import axios from "axios";
const DOMAINS = [
    {
        http: 'www.greeng.top',
    },
    {
        http: 'www.green-s.icu',
    },
    {
        http: 'www.greenx.cc',
    },
    {
        http:  'www.green-x.sbs',
    },
    {
        http:  'www.greeng.vip',
    },
    {
        http: 'www.greenx.icu',
    },
    {
        http: 'www.green-x.icu',
    },
];
let index = 0;
//测试接口
const instance = axios.create({
    timeout: 3000
});

export const getTest = () => {
    const domain: string = DOMAINS[index].http;
    if (!domain) return;
    instance.post(`https://${domain}/fe-ex-api/common/user_info`).then(response => {
        if (index <= 5 && response?.status === 200) {
            sessionStorage.setItem('domain', domain);
        }
    }).catch(error => {
        if (index <= DOMAINS.length) {
            index += 1;
            getTest();
            console.log(error);
        }
    });
}